import React, { useEffect, useState } from "react";
import TeamExpensesList from "../Components/TravelExpenses/TeamExpensesList";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import AccountantExpensesList from "../Components/TravelExpenses/AccountantExpensesList";
import AllExpenses from "../Components/TravelExpenses/HrAllExpenses/AllExpenses";
import ExpensesList from "../Components/TravelExpense/ExpensesList";

function HrAllExpenses() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>All Expenses</h1>
          </div>

          {comp == "view" ? (
            <>
              <ExpensesList
                comp={comp}
                onChange={handleChange}
                rowData={rowData}
              />
            </>
          ) : (
            <>
              <AllExpenses
                comp={comp}
                onChange={handleChange}
                rowData={rowData}
              />
            </>
          )}
        </section>
      </div>
    </Layout>
  );
}

export default HrAllExpenses;
